import { Component, Input, OnInit } from '@angular/core';
import { TrackingState } from './trackingstate';

@Component({
  selector: 'app-trackingstate',
  templateUrl: './trackingstate.component.html',
  styleUrls: ['./trackingstate.component.css']
})
export class TrackingstateComponent implements OnInit {

  @Input() state: TrackingState;

  constructor() { }

  ngOnInit(): void {
  }

}
